import React from 'react';
import './MenuMainMobile.scss';
import { Row, Icon } from 'antd';
import Link from 'Components/Shared/Link/Link';
import MenuSearch from 'Components/MenuSearch/MenuSearch';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import DropDown, { IDropdown } from 'Components/MenuMain/DropDown/DropDown';
import MessageSliderContainer from 'Components/MessageSlider/MessageSliderContainer';
import LanguagePicker from 'Components/Shared/LanguagePicker/LanguagePicker';

interface IProps {
  isStartPage: boolean;
  isShowingSearchForm: boolean;
  homeImageUrl: string;
  dropdownMobile: IDropdown;
  onSearchIconClick: () => void;
  onSearchCloseClick: () => void;
  onSearchChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onSearchSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const MenuMainMobile: React.SFC<IProps> = ({
  isStartPage,
  isShowingSearchForm,
  homeImageUrl,
  dropdownMobile,
  onSearchIconClick,
  onSearchCloseClick,
  onSearchChange,
  onSearchSubmit,
}) => {

  const style = isStartPage ? 'menu-main-mobile start-page' : 'menu-main-mobile category-page';

  return (
    <div className={ style }>
      <Row type='flex' align='middle' className='menu'>
        <Link
          style='home-item'
          imageAlt='Julius Biljettservice logga'
          imageUrl={ homeImageUrl }
          localPath='/'
        />
        <LanguagePicker />
        <div className='search-item' onClick={ onSearchIconClick }>
          <Icon type='search' />
          <FormattedText
            displayName='Sök'
            formattedName='menu.search'
          />
        </div>
        <DropDown { ...dropdownMobile }>
          <div className='dropdown-item'>
            <Icon type='bars' />
            <FormattedText
              displayName='Meny'
              formattedName='menu.menu'
            />
          </div>
        </DropDown>
      </Row>
      <MessageSliderContainer />
      { isShowingSearchForm && 
        <MenuSearch 
          onChange={ onSearchChange }
          onSubmit={ onSearchSubmit } 
          onClose={ onSearchCloseClick }
        /> 
      }
    </div>
  );
}

export default MenuMainMobile;


// WEBPACK FOOTER //
// ./src/components/MenuMain/MenuMainMobile/MenuMainMobile.tsx